import GridGallery from './GridGallery'

export default GridGallery
